<form
  *ngIf="(state$ | async)?.form as form"
  [formGroup]="form"
  class="form">
  <mat-form-field>
    <input
      matInput
      formControlName="codiceUnico"
      [placeholder]="'Codice Unico' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="SGT.SGTT"
      [placeholder]="'SGTT' | translate">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      formControlName="MTC"
      [placeholder]="'MTC' | translate">
  </mat-form-field>
</form>
